<template>
  <v-dialog v-model="visible" max-width="400px" persistent>
    <v-card>
      <v-toolbar dark flat dense :color="formColor">
        <v-toolbar-title><v-icon>error_outline</v-icon> {{ languagedTitle }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text v-html="text" class="pt-4 pb-0"></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="formColor" text @click="close">{{ getExpression('Button', 'OK') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { AppColor } from '@/config.js'
import AppError from '@/plugins/error.js'

export default {
  name: 'AppError',
  data() {
    return {
      formColor_Warning: AppColor.Warning,
      formColor_Error: AppColor.Error,
      visible: false,
      title: null,
      text: null,
      severity: null,
    }
  },
  computed: {
    formColor () {
      return this.severity === 0
        ? this.formColor_Warning
        : this.formColor_Error
    },
    languagedTitle () {
      return this.title !== null
        ? this.title
        : this.getExpression('FormTitle', 'InternalError')
    }
  },
  methods: {
    close () {
      this.visible = false
    },
    show (params) {
      this.visible = true
      if (!this.isNullOrUndefined(params.title)) this.title = params.title
      else this.title = null
      this.text = params.text
      this.severity = params.severity
      this.languageId = params.languageId
    }
  },
  beforeMount() {
    // here we need to listen for emited events
    // we declared those events inside our plugin
    AppError.EventBus.$on('show', (params) => {
      this.show(params)
    })
  }
}
</script>
